/* eslint-disable */
import axios from 'axios';
import { CookieStorage } from 'cookie-storage';

function Convince(config) {
  this.config = config;
  this.base = window.convinceConfig.base;
  this.csrfToken = this.getCSRFToken();
}

Convince.prototype = {
  notifyChannel: function(tokenId) {},
  start: function() {
    var promise = axios({
      method: 'post',
      url: this.base + '/start/' + this.config.campaignId,
      headers: { 'X-CSRF-Token': this.csrfToken },
      data: {
        url: location.href,
        account: this.config.account,
      },
    });
    promise
      .then(
        function(resp) {
          this.config = resp.data;
        }.bind(this)
      )
      .catch(this.onError.bind(this));
    return promise;
  },
  event: function(data) {
    var csrfToken = this.getCSRFToken();
    var payload = {
      uuid: this.config.responseId,
      source_type: 'response',
    };
    if (!this.config.responseId) {
      payload.source_type = 'campaign';
    }
    Object.assign(payload, data);
    var promise = axios({
      method: 'post',
      url: this.base + '/leads/' + this.config.campaignId + '.js',
      headers: { 'X-CSRF-Token': this.csrfToken },
      data: payload,
    });
    return promise;
  },
  update: function(data) {
    var payload = { data: data, method: '_put', token: this.config.tokenId };
    var csrfToken = this.getCSRFToken();
    var promise = axios({
      method: 'put',
      url: this.base + this.config.respondTo,
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  finalise: function() {
    var payload = {
      data: { complete: true },
      method: '_post',
      token: this.config.tokenId,
    };
    var csrfToken = this.getCSRFToken();
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/finalise',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  result: function(options) {
    var payload = { method: '_post', token: this.config.tokenId };
    if (typeof options !== 'undefined') {
      payload.options = options;
    }
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/result',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  response: function(uuid) {
    var promise = axios({
      method: 'get',
      url: `${this.base}/responses/${uuid}.js`,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  scores: async function(options) {
    if (!this.config.respondTo) {
      await this.start();
    }

    var payload = { method: '_post', token: this.config.tokenId };
    if (typeof options !== 'undefined') {
      payload.options = options;
    }

    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/scores',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  agreement: function(key) {
    var payload = { key: key, method: '_post', token: this.config.tokenId };
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/agreement',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  polling: function(key) {
    var payload = { key: key, method: '_post', token: this.config.tokenId };
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/poll',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  ranking: function(key) {
    var payload = { key: key, method: '_post', token: this.config.tokenId };
    var csrfToken = this.getCSRFToken();
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/ranking',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  breakdown: function(key) {
    var payload = { key: key, method: '_post', token: this.config.tokenId };
    var csrfToken = this.getCSRFToken();
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/breakdown',
      data: payload,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  promoteUser: function(fields) {
    var data = { fields: fields };
    data.token = this.config.tokenId;
    var csrfToken = this.getCSRFToken();
    var promise = axios({
      method: 'post',
      url: this.base + this.config.respondTo + '/promote_user',
      data: data,
      headers: { 'X-CSRF-Token': this.csrfToken },
    }).catch(this.onError.bind(this));
    return promise;
  },
  onError: function(e) {
    if (
      typeof this.config.errorCallback != 'undefined' &&
      this.config.errorCallback
    ) {
      this.errorCallback(e);
    }
    if (this.config.debug === true) {
      console.log(e);
    }
  },
  getCSRFToken: function() {
    var csrfToken = 'NOTOKEN';
    try {
      csrfToken = document
        .querySelectorAll("meta[name='csrf-token']")[0]
        .getAttribute('content');
    } catch (e) {}
    return csrfToken;
  },
  fieldDefault: function(value, defaultValue) {
    return typeof value == 'undefined' ? defaultValue : value.toString();
  },
};

export default Convince;
